export default "__VITE_ASSET__DWuZAZ$n__"